import {useContext} from 'react'

import {UpmPlantContext} from '../contexts'
import type {UpmPlant} from '../types'

export const useUpmPlantContext = (): UpmPlant => {
  const context = useContext(UpmPlantContext)

  if (!context) {
    throw new Error('useUpmPlantContext is used outside of the UpmPlantContext!')
  }

  return context
}
